/** God Email / Resend templates UI copy. */
export const emailAdminEn = {
  godConfigTabEmail: 'Email',
  godEmailConfig: 'Email & templates',
  emailMailboxSection: 'Mailboxes & inbound',
  emailTemplatesSection: 'Resend templates',
  emailWiredSection: 'Wired runtime aliases',
  emailStatusProvider: 'Provider',
  emailStatusFrom: 'Transactional From (noreply)',
  emailStatusSupport: 'Support mailbox',
  emailStatusForward: 'Gmail copy',
  emailStatusInbound: 'Inbound domain',
  emailStatusWebhook: 'Webhook secret',
  emailStatusWebhookUrl: 'Inbound webhook URL',
  emailStatusUserInbox: 'User reply address pattern',
  emailStatusConfigured: 'Configured',
  emailStatusMissing: 'Missing',
  emailStatusNotSet: 'Not set',
  emailInboxHint:
    'Mail to support@ creates a ticket and appears in the god/support in-app inbox. Staff↔user email replies use inbox+{uid}@domain. noreply@ is send-only for invites/MFA.',
  emailTplCreate: 'New template',
  emailTplEdit: 'Edit template',
  emailTplName: 'Name',
  emailTplAlias: 'Alias',
  emailTplSubject: 'Subject',
  emailTplHtml: 'HTML body',
  emailTplVariables: 'Variables (JSON)',
  emailTplSaveDraft: 'Save draft',
  emailTplSavePublish: 'Save & publish',
  emailTplPublish: 'Publish',
  emailTplEmpty: 'No templates in Resend yet. Create one or run email:templates:sync.',
  refresh: 'Refresh',
  edit: 'Edit',
} as const;

export const emailAdminEs = {
  godConfigTabEmail: 'Correo',
  godEmailConfig: 'Correo y plantillas',
  emailMailboxSection: 'Buzones y entrada',
  emailTemplatesSection: 'Plantillas Resend',
  emailWiredSection: 'Alias conectados al runtime',
  emailStatusProvider: 'Proveedor',
  emailStatusFrom: 'From transaccional (noreply)',
  emailStatusSupport: 'Buzón support',
  emailStatusForward: 'Copia a Gmail',
  emailStatusInbound: 'Dominio inbound',
  emailStatusWebhook: 'Secret del webhook',
  emailStatusWebhookUrl: 'URL del webhook inbound',
  emailStatusUserInbox: 'Patrón de respuesta de usuario',
  emailStatusConfigured: 'Configurado',
  emailStatusMissing: 'Falta',
  emailStatusNotSet: 'Sin definir',
  emailInboxHint:
    'Correo a support@ crea un ticket y aparece en la bandeja in-app de god/support. Respuestas staff↔usuario usan inbox+{uid}@dominio. noreply@ solo envía (invites/MFA).',
  emailTplCreate: 'Nueva plantilla',
  emailTplEdit: 'Editar plantilla',
  emailTplName: 'Nombre',
  emailTplAlias: 'Alias',
  emailTplSubject: 'Asunto',
  emailTplHtml: 'Cuerpo HTML',
  emailTplVariables: 'Variables (JSON)',
  emailTplSaveDraft: 'Guardar borrador',
  emailTplSavePublish: 'Guardar y publicar',
  emailTplPublish: 'Publicar',
  emailTplEmpty: 'Aún no hay plantillas en Resend. Crea una o ejecuta email:templates:sync.',
  refresh: 'Actualizar',
  edit: 'Editar',
} as const;
